<template>
  <b-container>
    <b-row>
      <b-col class="h-20 logo" cols="2">
        <img src="@/assets/5895deb9cba9841eabab6099.png" width="50px" height="60px">
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="12"
        md="5"
        order-md="1"
        order="2"
        style="padding-left: 40px; padding-right: 40px;"
      >
        <b-col class="h-20 header-text" cols="12">
          <div>
            <h2 class="text-left">Current health status?</h2>
          </div>
        </b-col>
        <b-col class="radios" cols="12">
          <div>
            <b-form-group class="intro-text" label="How do you feel right now?">
              <b-form-radio v-model="selected" :value="1">Healthy</b-form-radio>
              <b-form-radio v-model="selected" :value="2">Injured</b-form-radio>
            </b-form-group>
          </div>
        </b-col>
        <div class="btn-grp">
          <b-col class="float-left" cols="6">
            <b-button block v-on:click="$router.go(-1)">Prev</b-button>
          </b-col>

          <b-col class="float-right" cols="6">
            <b-button block v-on:click="onHome">Home</b-button>
          </b-col>
        </div>
      </b-col>

      <b-col cols="12" md="7" order-md="2" order="1">
        <div>
          <MyLottie :item="index"/>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import MyLottie from "@/components/MyLottie.vue";
export default {
  name: "Team",
  components: {
    MyLottie
  },
  props: {
    msg: String
  },
  data: function() {
    return {
      myValue: 0, //
      index: {}, //
      selected: {},
      options: [
        {
          value: parseInt(this.$route.params.num),
          segment: [376, 443],
          text: "Healthy"
        },
        {
          value: parseInt(this.$route.params.num),
          segment: [443, 509],
          text: "Injured"
        }
      ]
    };
  },
  mounted() {
    console.log("App mounted!");
    console.log(this.$route.params.num);
    this.index = {
      value: parseInt(this.$route.params.num),
      segment: [[286, 309], [309, 376]]
    };
  },
  watch: {
    selected: {
      handler() {
        this.index = this.options[this.selected - 1];
        console.log("selected");
      },
      deep: true
    }
  },
  methods: {
    onHome(next) {
      localStorage.removeItem("item"); /** clean actual selected */
      this.index = {}; /** clean actual selected */
      this.$router.push({ name: "home" });
    }
  }
};
</script>

<style scoped>
.box {
  padding-top: 20px;
}
.col-form-label,
fieldset,
legend {
  font-size: 18px !important;
  line-height: 22px !important;
  text-align: left;
}
.custom-radio {
  display: block;
  margin-left: 14px;
  padding: 20px;
}
.header {
  background: #0070bc;
  font-style: italic;
  color: white;
  height: 40px;
}
.btn-grp {
  margin-left: 10px;
}
.alto {
  height: 50px;
  width: 50px;
}
.ps {
  height: 300px;
}
.intro-text {
  margin-top: 10px;
  margin-bottom: 30px;
  padding-left: 0px;
}
.header-text {
  margin-top: 20%;
  margin-bottom: 30px;
  padding-left: 30px;
}

@media only screen and (max-width: 600px) {
  .header-text {
    margin-top: 0;
  }
}
@media only screen and (min-width: 767px) {
  div#myLottie {
    position: relative;
    bottom: 0;
  }
}
button.btn.btn-secondary {
  background-color: #004986;
  border-radius: 15px;
}
button.btn.btn-secondary:hover {
  background-color: #004986c7;
  cursor: pointer;
}
.custom-control {
  padding: 5px;
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  div#myLottie {
    position: relative;
    top: 0;
  }
  .header-text {
    margin-top: 0;
    margin-bottom: 0;
    padding-left: 0px;
  }
  h2 {
    text-align: center !important;
  }
  .intro-text {
    margin-top: 10px;
    margin-top: 0;
    margin-bottom: 30px;
  }
  .ps {
    height: 200px;
  }
  button.btn.btn-secondary {
    background-color: #004986;
  }
  button.btn.btn-secondary:hover {
    background-color: #004986c7;
    cursor: pointer;
  }
  .select-field {
    margin-top: 0;
    margin-bottom: 100px;
    padding-left: 30px;
  }
  .logo {
    padding-left: 33px;
  }
  .radios {
    margin-top: 40px;
    margin-bottom: 40px;
  }
  .custom-control {
    padding: 5px;
  }
  .col-form-label,
  fieldset,
  legend {
    font-size: 18px !important;
    line-height: 22px !important;
    text-align: center !important;
  }
  .custom-radio {
    display: block;
    margin-left: 0;
    padding: 0;
  }
}
</style>